// CANLI DOĞURANLAR - balikVeritabani1.js
// Wikipedia Commons ücretsiz resimler kullanılmıştır

export const canliDoguranlar = {
  kategori: {
    id: 'canli-doguranlar',
    isim: 'Canlı Doğuranlar',
    emoji: '🐟',
    renk: '#e74c3c',
    aciklama: 'Yavru doğuran tatlı su balıkları - Poeciliidae ailesi'
  },
  baliklar: [
    {
      id: 'guppy',
      isim: 'Lepistes (Guppy)',
      latince: 'Poecilia reticulata',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Guppy_copance_0048.jpg/1280px-Guppy_copance_0048.jpg',
      zorluk: 'Kolay',
      genel: 'Akvaryum hobisinin en popüler balığı. Erkekleri renkli ve gösterişli kuyrukları ile bilinir. Venezuela ve Trinidad kökenlidir. İlk kez 1866\'da Robert John Lechmere Guppy tarafından tanımlanmıştır.',
      minLitre: 40,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.8, max: 7.8 },
      sertlik: { min: 8, max: 15 },
      yasam: '2-3 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Pul yem, canlı yem, dondurulmuş yem. Günde 2-3 kez az miktarda beslenmelidir.',
      uyumlu: ['Molly', 'Plati', 'Kılıçkuyruk', 'Corydoras', 'Neon Tetra', 'Rasbora', 'Otocinclus'],
      uyumsuz: ['Betta', 'Büyük Cikletler', 'Kaplan Barb', 'Angel (yetişkin)', 'Oscar'],
      ureme: 'Canlı doğuran. Dişi 4-6 haftada bir 20-100 yavru doğurur. Gebelik süresi 21-30 gün.',
      eslesme: 'Erkekler sürekli dişileri kovalar. Gonopodyum ile iç döllenme yapar.',
      grupSayisi: '6+ (1 erkek / 2-3 dişi)',
      disiErkek: '1 erkek için 2-3 dişi önerilir. Aksi halde dişiler strese girer.',
      gorunus: 'Erkekler küçük (3cm) ve çok renklidir. Kuyrukları vücutlarından büyük olabilir. Kırmızı, mavi, sarı, turuncu, siyah ve bunların kombinasyonları görülür. Dişiler daha büyük (5cm), soluk renkli ve tombuldur. Yüzlerce renk ve kuyruk varyasyonu mevcuttur: Cobra, Tuxedo, Half-black, Snakeskin, Mosaic.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'molly-siyah',
      isim: 'Siyah Molly',
      latince: 'Poecilia sphenops',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Black_Molly.jpg/1280px-Black_Molly.jpg',
      zorluk: 'Kolay',
      genel: 'En popüler Molly çeşidi. Tamamen siyah rengiyle dikkat çeker. Meksika ve Orta Amerika kökenlidir. Tuzlu suya toleranslıdır.',
      minLitre: 80,
      maxBoy: 10,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.0, max: 8.5 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Bitkisel ağırlıklı beslenmeli. Alg, spirulina, sebze severler. Pul ve granül yem.',
      uyumlu: ['Guppy', 'Plati', 'Kılıçkuyruk', 'Corydoras', 'Tetralar', 'Gurami', 'Gökkuşağı'],
      uyumsuz: ['Betta', 'Agresif Cikletler', 'Çok küçük balıklar'],
      ureme: 'Canlı doğuran. 4-8 haftada bir 20-100 yavru doğurur.',
      eslesme: 'Erkekler dişileri kovalar. Yeterli dişi olmazsa stres oluşur.',
      grupSayisi: '4+ (1 erkek / 2-3 dişi)',
      disiErkek: '1 erkek için 2-3 dişi önerilir.',
      gorunus: 'Tamamen kadife siyah renk. Geniş ve yuvarlak vücutlu. Erkeklerin gonopodyumu (sivri anal yüzgeci) vardır. Lyretail (lir kuyruk) varyasyonu da mevcuttur.',
      kaynaklar: ['fishbase.org', 'akvaryum.com']
    },
    {
      id: 'molly-balloon',
      isim: 'Balloon Molly',
      latince: 'Poecilia sphenops var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Balloon_molly.jpg/1280px-Balloon_molly.jpg',
      zorluk: 'Kolay',
      genel: 'Selektif üretimle elde edilmiş yuvarlak karınlı Molly çeşidi. Omurgası kısaltılmış, bu yüzden bazı hobiciler tarafından eleştirilir.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.0, max: 8.5 },
      sertlik: { min: 10, max: 25 },
      yasam: '2-3 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Dengeli beslenme önemli. Aşırı yemlemeden kaçının.',
      uyumlu: ['Guppy', 'Plati', 'Diğer Molly türleri', 'Corydoras'],
      uyumsuz: ['Hızlı yüzücüler', 'Agresif türler'],
      ureme: 'Canlı doğuran. Normal Molly gibi ürer ama daha az verimli.',
      eslesme: 'Standart Molly davranışı.',
      grupSayisi: '4+',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Yuvarlak, balon gibi şişkin karın. Kısa vücut. Turuncu, sarı, siyah, beyaz ve dalmasyalı renk formları mevcut.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'molly-sailfin',
      isim: 'Sailfin Molly',
      latince: 'Poecilia latipinna',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Sailfin_molly.jpg/1280px-Sailfin_molly.jpg',
      zorluk: 'Kolay',
      genel: 'Erkeklerin büyük yelken şeklinde sırt yüzgeci ile tanınır. ABD\'nin güneydoğu kıyılarında doğal olarak bulunur. Tuzlu suya çok toleranslı.',
      minLitre: 120,
      maxBoy: 15,
      sicaklik: { min: 20, max: 28 },
      ph: { min: 7.0, max: 8.5 },
      sertlik: { min: 15, max: 30 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Yüksek bitkisel içerik gerekir. Alg ve spirulina.',
      uyumlu: ['Diğer Molly türleri', 'Plati', 'Kılıçkuyruk', 'Orta boy barışçıl balıklar'],
      uyumsuz: ['Küçük balıklar', 'Yumuşak su balıkları'],
      ureme: 'Canlı doğuran. 50-100 yavru.',
      eslesme: 'Erkek yüzgecini açarak dişiye gösteriş yapar.',
      grupSayisi: '4+ (1 erkek / 3 dişi)',
      disiErkek: '1 erkek için 3 dişi',
      gorunus: 'Büyük, yelken şeklinde sırt yüzgeci erkeklerde çok belirgin. Gümüşi-yeşil vücut, mavimsi yansımalar. Gri, gümüş, altın ve dalmasyalı formlar mevcut.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'molly-dalmatian',
      isim: 'Dalmaçyalı Molly',
      latince: 'Poecilia sphenops var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Dalmatian_molly.JPG/1280px-Dalmatian_molly.JPG',
      zorluk: 'Kolay',
      genel: 'Beyaz zemin üzerinde siyah beneklerle Dalmaçyalı köpeğine benzer. Çok popüler bir süs formu.',
      minLitre: 80,
      maxBoy: 10,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.0, max: 8.5 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Standart Molly beslenmesi.',
      uyumlu: ['Guppy', 'Plati', 'Diğer Molly türleri', 'Corydoras', 'Tetralar'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Standart Molly davranışı.',
      grupSayisi: '4+',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Beyaz veya gümüşi zemin üzerinde rastgele dağılmış siyah benekler. Her bireyin deseni benzersizdir.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'plati',
      isim: 'Plati',
      latince: 'Xiphophorus maculatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Xiphophorus_maculatus_-_Wagtail_Platy.jpg/1280px-Xiphophorus_maculatus_-_Wagtail_Platy.jpg',
      zorluk: 'Kolay',
      genel: 'Meksika ve Guatemala kökenli. Çok renkli, barışçıl ve dayanıklı. Başlangıç için ideal balıklardan biri.',
      minLitre: 60,
      maxBoy: 7,
      sicaklik: { min: 20, max: 28 },
      ph: { min: 7.0, max: 8.2 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-4 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Her türlü yemi kabul eder. Pul, granül, canlı ve dondurulmuş yemler.',
      uyumlu: ['Guppy', 'Molly', 'Kılıçkuyruk', 'Corydoras', 'Tetralar', 'Rasbora'],
      uyumsuz: ['Agresif türler', 'Çok büyük balıklar'],
      ureme: 'Canlı doğuran. Ayda bir 20-80 yavru.',
      eslesme: 'Kolay ürer, erkekler aktif kovalayıcıdır.',
      grupSayisi: '5+ (1 erkek / 2 dişi)',
      disiErkek: '1 erkek için en az 2 dişi.',
      gorunus: 'Kısa ve dolgun vücutlu. Çok sayıda renk varyasyonu: Kırmızı, turuncu, sarı, mavi, siyah. Mickey Mouse, Sunset, Tuxedo, Wagtail, Salt&Pepper desenleri popüler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'plati-mickey',
      isim: 'Mickey Mouse Plati',
      latince: 'Xiphophorus maculatus var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Mickey_Mouse_platy.jpg/1280px-Mickey_Mouse_platy.jpg',
      zorluk: 'Kolay',
      genel: 'Kuyruk dibindeki Mickey Mouse silueti benzeri desenle tanınır. Çocuklar ve aile akvaryumları için çok popüler.',
      minLitre: 60,
      maxBoy: 7,
      sicaklik: { min: 20, max: 28 },
      ph: { min: 7.0, max: 8.2 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-4 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Standart Plati beslenmesi.',
      uyumlu: ['Guppy', 'Molly', 'Diğer Plati türleri', 'Corydoras', 'Tetralar'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Standart Plati davranışı.',
      grupSayisi: '5+',
      disiErkek: '1 erkek / 2 dişi',
      gorunus: 'Sarı veya turuncu vücut. Kuyruk dibinde büyük bir yuvarlak leke ve iki küçük yuvarlak leke Mickey Mouse şeklini oluşturur.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'kilickuyruk',
      isim: 'Kılıçkuyruk',
      latince: 'Xiphophorus hellerii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Xiphophorus_hellerii_02.jpg/1280px-Xiphophorus_hellerii_02.jpg',
      zorluk: 'Kolay',
      genel: 'Erkeklerin kuyruk yüzgecindeki kılıç şeklinde uzantı ile tanınır. Meksika ve Orta Amerika kökenli. Aktif yüzücü, kapaklı akvaryum gerektirir.',
      minLitre: 100,
      maxBoy: 14,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 7.0, max: 8.3 },
      sertlik: { min: 12, max: 25 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Dengeli beslenme gerekir. Bitkisel ve hayvansal karışım.',
      uyumlu: ['Guppy', 'Molly', 'Plati', 'Corydoras', 'Barb türleri', 'Tetralar'],
      uyumsuz: ['Uzun yüzgeçli balıklar', 'Çok küçük türler', 'Diğer erkek Kılıçkuyruklar'],
      ureme: 'Canlı doğuran. 4-6 haftada bir 20-150 yavru.',
      eslesme: 'Erkekler baskın olabilir. Birden fazla erkek kavga edebilir. Hiyerarşi oluşur.',
      grupSayisi: '4+ (1 erkek / 3 dişi)',
      disiErkek: 'Tek erkek veya 1 erkek / 3+ dişi oranı.',
      gorunus: 'Uzun ve aerodinamik vücut. Erkeklerde kuyruktan uzanan kılıç şeklinde uzantı 3-4 cm olabilir. Yeşil, kırmızı, siyah, turuncu, sarı, neon renklerde. Hi-Fin varyasyonu yüksek sırt yüzgecine sahip.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com', 'akvaryum.com']
    },
    {
      id: 'kilickuyruk-kirmizi',
      isim: 'Kırmızı Kılıçkuyruk',
      latince: 'Xiphophorus hellerii var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Xiphophorus_hellerii_red.jpg/1280px-Xiphophorus_hellerii_red.jpg',
      zorluk: 'Kolay',
      genel: 'En popüler Kılıçkuyruk renk formu. Canlı kırmızı rengiyle akvaryumlarda dikkat çeker.',
      minLitre: 100,
      maxBoy: 14,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 7.0, max: 8.3 },
      sertlik: { min: 12, max: 25 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor',
      uyumlu: ['Molly', 'Plati', 'Corydoras', 'Orta boy topluluk balıkları'],
      uyumsuz: ['Diğer erkek Kılıçkuyruklar', 'Çok küçük balıklar'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Standart Kılıçkuyruk davranışı.',
      grupSayisi: '4+',
      disiErkek: '1 erkek / 3 dişi',
      gorunus: 'Tamamen parlak kırmızı renk. Kılıç uzantısı da kırmızı veya siyah kenarlı olabilir.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'endler',
      isim: 'Endler',
      latince: 'Poecilia wingei',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Poecilia_wingei_male.jpg/1280px-Poecilia_wingei_male.jpg',
      zorluk: 'Kolay',
      genel: 'Venezuela\'nın Laguna de Patos bölgesine endemik. Guppy\'nin küçük kuzeni. Doğal renkleri çok canlıdır. Dr. John Endler tarafından 1975\'te yeniden keşfedilmiştir.',
      minLitre: 30,
      maxBoy: 3,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '2-3 yıl',
      bolge: 'Üst',
      beslenme: 'Omnivor - Küçük taneli yemler, mikro yemler.',
      uyumlu: ['Küçük Tetralar', 'Rasbora', 'Corydoras', 'Karides', 'Otocinclus'],
      uyumsuz: ['Büyük balıklar', 'Guppy (melezleme istemiyorsanız)'],
      ureme: 'Canlı doğuran. Çok hızlı ürer. Her 23-24 günde 5-25 yavru.',
      eslesme: 'Guppy gibi, erkekler aktif kovalayıcı.',
      grupSayisi: '6+ (1 erkek / 2 dişi)',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Guppy\'den küçük. Erkekler neon renkli - turuncu, yeşil, siyah desenli. Metalik parlaklık. Dişiler soluk gri-yeşil. Tiger, Black Bar, Peacock gibi çeşitler var.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'gambusya',
      isim: 'Sivrisinek Balığı (Gambusya)',
      latince: 'Gambusia affinis',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Gambusia_affinis_female.jpg/1280px-Gambusia_affinis_female.jpg',
      zorluk: 'Kolay',
      genel: 'Sivrisinek larvası yiyerek sıtma kontrolünde kullanılmıştır. ABD kökenli ama dünya genelinde yayılmıştır. Çok dayanıklı ama agresif olabilir.',
      minLitre: 40,
      maxBoy: 7,
      sicaklik: { min: 12, max: 30 },
      ph: { min: 6.0, max: 8.5 },
      sertlik: { min: 5, max: 25 },
      yasam: '2-3 yıl',
      bolge: 'Üst',
      beslenme: 'Omnivor - Böcek larvaları, canlı yem, pul yem.',
      uyumlu: ['Kendi türü', 'Dayanıklı türler'],
      uyumsuz: ['Uzun yüzgeçli balıklar', 'Yavaş balıklar', 'Küçük balıklar'],
      ureme: 'Canlı doğuran. Çok verimli.',
      eslesme: 'Erkekler agresif olabilir.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 3 dişi',
      gorunus: 'Gri-yeşil, sade görünüm. Dişiler daha büyük. Karın bölgesinde hamilelik lekesi belirgin.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'heterandria-formosa',
      isim: 'Cüce Canlı Doğuran',
      latince: 'Heterandria formosa',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Heterandria_formosa_male.jpg/1280px-Heterandria_formosa_male.jpg',
      zorluk: 'Orta',
      genel: 'Dünyanın en küçük balıklarından biri. ABD\'nin güneydoğu kıyılarında bulunur. Nano akvaryumlar için idealdir.',
      minLitre: 20,
      maxBoy: 3,
      sicaklik: { min: 18, max: 26 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '2-3 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Çok küçük yemler, mikro yemler, bebi yemler.',
      uyumlu: ['Diğer küçük balıklar', 'Karides', 'Salyangoz'],
      uyumsuz: ['Tüm büyük balıklar'],
      ureme: 'Canlı doğuran. Süper fetasyon yapabilir (birden fazla hamilelik aynı anda).',
      eslesme: 'Benzersiz üreme - günde 1-2 yavru doğurabilir.',
      grupSayisi: '8+',
      disiErkek: '1 erkek / 3 dişi',
      gorunus: 'Çok küçük. Zeytin yeşili vücut, siyah yatay çizgi. Erkekler 2cm, dişiler 3cm.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'limia-nigrofasciata',
      isim: 'Çizgili Limia',
      latince: 'Limia nigrofasciata',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Limia_nigrofasciata_male.jpg/1280px-Limia_nigrofasciata_male.jpg',
      zorluk: 'Kolay',
      genel: 'Haiti\'ye endemik. Humpback Limia olarak da bilinir. Erkeklerin sırtında belirgin bir kamburları vardır.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 7.0, max: 8.5 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-4 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Alg ve bitkisel yemler önemli.',
      uyumlu: ['Guppy', 'Molly', 'Plati', 'Barışçıl türler'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Erkekler kambur ve renkli.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Sarımsı vücut üzerinde dikey siyah çizgiler. Erkeklerin sırtında belirgin kambur. Yaşlandıkça erkekler daha kambur ve renkli olur.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'priapella-intermedia',
      isim: 'Blue-eye Livebearer',
      latince: 'Priapella intermedia',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Priapella_intermedia.jpg/640px-Priapella_intermedia.jpg',
      zorluk: 'Orta',
      genel: 'Meksika\'ya endemik. Mavi gözleriyle dikkat çeker. Doğada nesli tehlike altında.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Canlı ve dondurulmuş yem tercih eder.',
      uyumlu: ['Barışçıl topluluk balıkları'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Canlı doğuran. Diğer canlı doğuranlardan daha az sayıda yavru.',
      eslesme: 'Sakin üreme davranışı.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2 dişi',
      gorunus: 'İnce, zarif vücut. Parlak mavi gözler. Şeffaf-gümüşi vücut.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'xenotoca-eiseni',
      isim: 'Red-tail Goodeid',
      latince: 'Xenotoca eiseni',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Xenotoca_eiseni_male.jpg/1280px-Xenotoca_eiseni_male.jpg',
      zorluk: 'Orta',
      genel: 'Meksika\'ya endemik Goodeid ailesi. Gerçek plasenta ile yavru besler (diğer canlı doğuranlardan farklı). Erkeklerin kuyrukları kırmızı-turuncu.',
      minLitre: 100,
      maxBoy: 8,
      sicaklik: { min: 18, max: 26 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Bitkisel ağırlıklı.',
      uyumlu: ['Diğer Goodeid türleri', 'Orta boy barışçıl balıklar'],
      uyumsuz: ['Yavaş, uzun yüzgeçli balıklar'],
      ureme: 'Canlı doğuran (viviparity). Gerçek plasenta ile beslenme.',
      eslesme: 'Erkekler yarı-agresif olabilir.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2 dişi',
      gorunus: 'Erkekler mavimsi vücut ve parlak turuncu-kırmızı kuyruk. Dişiler daha soluk.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'girardinus-metallicus',
      isim: 'Metalik Girardinus',
      latince: 'Girardinus metallicus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Girardinus_metallicus.jpg/640px-Girardinus_metallicus.jpg',
      zorluk: 'Kolay',
      genel: 'Küba\'ya endemik. Metalik parlaklığı ile tanınır. Soğuğa oldukça toleranslı.',
      minLitre: 40,
      maxBoy: 6,
      sicaklik: { min: 18, max: 28 },
      ph: { min: 7.0, max: 8.5 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-4 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer küçük canlı doğuranlar', 'Barışçıl türler'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Standart canlı doğuran davranışı.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Metalik yeşil-mavi parlaklık. Erkeklerde karın altında siyah çizgiler. Dişiler daha iri.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'alfaro-cultratus',
      isim: 'Knife Livebearer',
      latince: 'Alfaro cultratus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Alfaro_cultratus.jpg/640px-Alfaro_cultratus.jpg',
      zorluk: 'Orta',
      genel: 'Orta Amerika kökenli. Karın altındaki bıçak şeklinde çıkıntı ile tanınır. İyi zıplayıcıdır, kapaklı akvaryum gerektirir.',
      minLitre: 100,
      maxBoy: 8,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '3-5 yıl',
      bolge: 'Üst',
      beslenme: 'Omnivor - Böcek ve canlı yem tercih eder.',
      uyumlu: ['Diğer aktif balıklar'],
      uyumsuz: ['Yavaş türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Aktif üreyen.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2 dişi',
      gorunus: 'İnce, aerodinamik vücut. Karın altında bıçak benzeri keskin çıkıntı. Şeffaf-yeşilimsi.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'poecilia-velifera',
      isim: 'Yucatan Molly',
      latince: 'Poecilia velifera',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Poecilia_velifera.jpg/1280px-Poecilia_velifera.jpg',
      zorluk: 'Orta',
      genel: 'Meksika Yucatan yarımadasına endemik. Sailfin Molly\'den daha büyük yelken yüzgecine sahip en büyük Molly türü.',
      minLitre: 200,
      maxBoy: 18,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.5, max: 8.5 },
      sertlik: { min: 15, max: 30 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Yüksek bitkisel içerik.',
      uyumlu: ['Büyük barışçıl balıklar'],
      uyumsuz: ['Küçük balıklar', 'Yumuşak su balıkları'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Erkek devasa yüzgecini açarak gösteriş yapar.',
      grupSayisi: '4+',
      disiErkek: '1 erkek / 3 dişi',
      gorunus: 'Devasa yelken şeklinde sırt yüzgeci - 5cm veya daha yüksek olabilir. Yeşil-mavi metalik parlaklık.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'guppy-cobra',
      isim: 'Cobra Guppy',
      latince: 'Poecilia reticulata var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Guppy_male_cobra.jpg/640px-Guppy_male_cobra.jpg',
      zorluk: 'Kolay',
      genel: 'Vücudundaki yılan derisi benzeri desenle tanınır. Çok popüler guppy varyasyonu.',
      minLitre: 40,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.8, max: 7.8 },
      sertlik: { min: 8, max: 15 },
      yasam: '2-3 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Molly', 'Plati', 'Corydoras', 'Tetralar'],
      uyumsuz: ['Betta', 'Agresif türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Standart guppy davranışı.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Vücutta yılan derisi/cobra deseni - metalik renk üzerinde düzensiz siyah lekeler ve çizgiler. Sarı, yeşil, mavi cobra tipleri mevcut.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'guppy-tuxedo',
      isim: 'Tuxedo Guppy',
      latince: 'Poecilia reticulata var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Guppy_tuxedo.jpg/640px-Guppy_tuxedo.jpg',
      zorluk: 'Kolay',
      genel: 'Vücudun arka yarısı koyu renk (smokin gibi) ile tanınır. Elegance ve kontrast için popüler.',
      minLitre: 40,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.8, max: 7.8 },
      sertlik: { min: 8, max: 15 },
      yasam: '2-3 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Molly', 'Plati', 'Corydoras', 'Tetralar'],
      uyumsuz: ['Betta', 'Agresif türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Standart guppy davranışı.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Ön yarı açık renk, arka yarı koyu renk - smokin efekti. Mavi, kırmızı, sarı kuyruk kombinasyonları.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'guppy-dumbo',
      isim: 'Dumbo Ear Guppy',
      latince: 'Poecilia reticulata var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Dumbo_guppy.jpg/640px-Dumbo_guppy.jpg',
      zorluk: 'Kolay',
      genel: 'Büyük, fil kulağı şeklinde göğüs yüzgeçleri ile tanınır. Son yıllarda çok popüler olmuş varyasyon.',
      minLitre: 40,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.8, max: 7.8 },
      sertlik: { min: 8, max: 15 },
      yasam: '2-3 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Molly', 'Plati', 'Corydoras', 'Barışçıl türler'],
      uyumsuz: ['Yüzgeç ısırıcılar', 'Agresif türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Standart guppy davranışı.',
      grupSayisi: '6+',
      disiErkek: '1 erkek / 2-3 dişi',
      gorunus: 'Normal guppy vücudu ama göğüs yüzgeçleri çok büyük ve yelpaze şeklinde. Tüm renklerde mevcut.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'micropoecilia-picta',
      isim: 'Swamp Guppy',
      latince: 'Micropoecilia picta',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Micropoecilia_picta.jpg/640px-Micropoecilia_picta.jpg',
      zorluk: 'Orta',
      genel: 'Trinidad ve Güney Amerika bataklıklarından. Acı suya toleranslı. Guppy\'den daha küçük ve farklı davranışlı.',
      minLitre: 40,
      maxBoy: 3,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 7.0, max: 8.5 },
      sertlik: { min: 10, max: 25 },
      yasam: '2-3 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Küçük barışçıl balıklar'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Sakin üreme davranışı.',
      grupSayisi: '8+',
      disiErkek: '1 erkek / 2 dişi',
      gorunus: 'Küçük. Erkekler renkli - kırmızı, mavi, siyah desenler. Kırmızı kuyruk yaygın.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'xiphophorus-variatus',
      isim: 'Değişken Plati',
      latince: 'Xiphophorus variatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Xiphophorus_variatus.jpg/1280px-Xiphophorus_variatus.jpg',
      zorluk: 'Kolay',
      genel: 'Meksika kökenli. Normal platiden daha uzun vücutlu ve farklı renk paternleri var. Soğuğa daha toleranslı.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 15, max: 28 },
      ph: { min: 7.0, max: 8.2 },
      sertlik: { min: 10, max: 25 },
      yasam: '3-5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer canlı doğuranlar', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Canlı doğuran.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '5+',
      disiErkek: '1 erkek / 2 dişi',
      gorunus: 'Uzunca vücut. Sunset, Hawaii, Marigold, Redtail ve daha birçok renk formu. Genellikle sarı-turuncu tonlar baskın.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export default canliDoguranlar;